import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import {
  Divider,
  Stack,
  Typography,
  useTheme,
  Skeleton,
  Tooltip,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { UnitType } from "src/store/api/generatedApi";

export const SummaryStat = ({
  label,
  value,
  decimalPlaces,
  units,
  hideDivider,
  loading,
  labelOverride,
  tooltip,
}: {
  label: string;
  value: number | null;
  decimalPlaces: number;
  units: UnitType | null;
  hideDivider?: boolean;
  loading?: boolean;
  labelOverride?: string;
  tooltip?: string;
}) => {
  const { format } = useNumberSerialiser({ decimalPlaces });
  const unitsFormatter = useUnitsFormatter(false);
  const { t } = useTenantTranslation();
  const theme = useTheme();

  return (
    <Stack direction="row" gap={3}>
      <Stack>
        {loading ? (
          <Skeleton variant="text" width={120} />
        ) : (
          <Typography variant="body1Mono">
            {value !== null
              ? `${format(value)}
          ${units == null ? "" : unitsFormatter(units)}`
              : "N/A"}
          </Typography>
        )}
        {loading ? (
          <Skeleton variant="text" width={80} />
        ) : (
          <Stack direction="row" alignItems="center" gap={0.5}>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.secondary }}
            >
              {labelOverride ?? t(label)}
            </Typography>
            {tooltip ? (
              <Tooltip title={tooltip} arrow>
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 16,
                    color: theme.palette.text.disabled,
                    cursor: "help",
                  }}
                />
              </Tooltip>
            ) : null}
          </Stack>
        )}
      </Stack>
      {!hideDivider && <Divider orientation="vertical" />}
    </Stack>
  );
};
